import React from 'react';
import { WorkspaceWindowPanelType } from '../types';

type Context = {
    /**
     * If true this component is being rendered in another window
     */
    active: boolean;

    /**
     * The root of the document
     */
    root?: HTMLElement;

    /**
     * Window handle
     */
    window?: WindowProxy;
};

export const MultiWindowContext = React.createContext<Context>({ active: false });

export function useMultiWindowContext() {
    return React.useContext(MultiWindowContext);
}

export function getMaxPanelCount(type: WorkspaceWindowPanelType): number {
    if (type === WorkspaceWindowPanelType.airportSummary) {
        return 2;
    }

    return 1;
}
